export default __webpack_public_path__ + "static/media/Extreme Wind Events 779d6a8127f3491f996e80848b16a961.6d346759.md";